import Vue from "vue";
import Buefy from "buefy";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheckCircle,
  faTimesCircle,
  faClipboard,
  faPlusSquare,
  faMinusSquare,
  faTimes,
  faChevronUp,
  faChevronDown,
  faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//import widgets in main so they can be dynamically loaded in component_details
import OpenServicesNaicsLookup from "../node_modules/@bizpal/open-services-naics-lookup/src/open-services-naics-lookup.vue";
import OpenServicesSgcLookup from "../node_modules/@bizpal/open-services-sgc-lookup/src/open-services-sgc-lookup.vue";
import OpenServicesWageWidget from "@bizpal/open-services-wage-widget";
import OpenServicesTreeNaicsLookup from "@bizpal/open-services-tree-naics-lookup/src/open-services-tree-naics-lookup.vue";
//import widget dependencies
import vSelect from "vue-select";

// add icons to library
library.add(
  faCheckCircle,
  faTimesCircle,
  faClipboard,
  faPlusSquare,
  faMinusSquare,
  faTimes,
  faChevronUp,
  faChevronDown,
  faQuestionCircle
);

//register widgets and font awesome icon as components
Vue.component("v-select", vSelect);
Vue.component("open-services-naics-lookup", OpenServicesNaicsLookup);
Vue.component("open-services-sgc-lookup", OpenServicesSgcLookup);
Vue.component("open-services-wage-widget", OpenServicesWageWidget);
Vue.component("open-services-tree-naics-lookup", OpenServicesTreeNaicsLookup);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Buefy);

// Moved App import here to fix CSS overwriting issues with components
import App from "./App.vue";
import router from "./router";
import store from "@/store/store";
import { i18n } from "./plugins/i18n.js";
// GTM
import VueGtm from "vue-gtm";

Vue.use(VueGtm, {
  id: "GTM-MR4689K",
  enabled: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
